import controllerDataConfigApi from '@/api/admin/controllerDataConfigApi'
import { queryKeys } from '@/constant/common'
import { SearchParams } from '@/types/common'
import { ControllerByLocationId } from '@/types/controller'
import { QueryOptions, useQuery, UseQueryResult } from '@tanstack/react-query'

function useSearchControllerLocation(
  searchParams: SearchParams = {},
  queryOptions?: QueryOptions,
): UseQueryResult<ControllerByLocationId> {
  return useQuery(
    [queryKeys.siteLocation, searchParams],
    async () => {
      const { data } = await controllerDataConfigApi.getByLocationId({
        ...searchParams,
      })

      if (!data) return null

      return data
    },
    queryOptions,
  )
}

export default useSearchControllerLocation
